import { GIANT_IDS, type GiantId } from '../ids/ids';
import { CLAUDI_PAIR_COUNT } from './secondChanceRules';

/**
 * Выбрать `pairCount` разных giant id для картинок пар.
 * Предпочитает `preferredGiant`, затем остальные в стабильном порядке с shuffle.
 */
export function pickClaudiPairGiantIds(
  preferredGiant: GiantId,
  pairCount: number = CLAUDI_PAIR_COUNT,
  random: () => number = Math.random,
): GiantId[] {
  const rest = GIANT_IDS.filter((id) => id !== preferredGiant);
  const shuffledRest = [...rest];
  for (let i = shuffledRest.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    const tmp = shuffledRest[i];
    shuffledRest[i] = shuffledRest[j];
    shuffledRest[j] = tmp;
  }
  const picked: GiantId[] = [preferredGiant];
  for (const id of shuffledRest) {
    if (picked.length >= pairCount) {
      break;
    }
    picked.push(id);
  }
  return picked.slice(0, pairCount);
}

export type ClaudiPairCard = {
  id: string;
  pairId: string;
  giantId: GiantId;
};

/** 6 карточек: по две на каждый pair giant, позиции перемешаны. */
export function createClaudiPairDeck(
  pairGiants: readonly GiantId[],
  random: () => number = Math.random,
): ClaudiPairCard[] {
  const cards: ClaudiPairCard[] = [];
  pairGiants.forEach((giantId, pairIndex) => {
    const pairId = `pair-${pairIndex}`;
    cards.push({ id: `${pairId}-a`, pairId, giantId });
    cards.push({ id: `${pairId}-b`, pairId, giantId });
  });
  for (let i = cards.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    const tmp = cards[i];
    cards[i] = cards[j];
    cards[j] = tmp;
  }
  return cards;
}
